<template>
  <div class="container">
    <div class="warp">
      <div class="content">
        <div class="title">
          机构认证
          <div class="close-back" @click="closePage">
            <close-outlined />
          </div>
        </div>
        <div class="AddOrExpiry">
          <a-space :size="50" direction="horizontal">
            <span>当前环境IP</span>
            <span class="red">{{ currentIp }}<check-circle-filled /></span>
            <span>认证有效期</span>
            <span class="red" v-if="curDay == 1">180天</span>
            <span class="red" v-else>0天</span>
          </a-space>
        </div>
        <div class="relevant">
          <a-space :size="30" direction="vertical">
            <a-row>
              <a-col :span="8">当前IP对应机构</a-col>
              <a-col :span="16">
                <a-select style="width: 356px" v-model:value="currentIpOrg">
                  <template #suffixIcon>
                    <a-tooltip placement="bottom">
                      <setting-outlined
                        class="setting"
                        @click="selectCurrentOrg"
                      />
                      <template #title>
                        <span>将此机构设为您的机构</span>
                      </template>
                    </a-tooltip>
                  </template>
                  <a-select-option
                    v-for="item in ipGroupList"
                    :key="item.collegeId"
                    :value="item.collegeId"
                    >{{
                      item.groupName + "-" + item.collegeName
                    }}</a-select-option
                  >
                </a-select>
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="8">当前您所在的机构</a-col>
              <a-col :span="16">
                <a-select
                  show-search
                  style="width: 356px"
                  v-model:value="selectedOrg"
                  @search="handleSearch"
                  @change="handleChange"
                  :filterOption="
                    (inputValue, option) => filterOption(inputValue, option)
                  "
                >
                  <template #suffixIcon
                    ><i
                      class="iconfont icon-sousuo"
                      style="position: relative; top: -2px"
                    ></i
                  ></template>
                  <a-select-option
                    v-for="item in orgList"
                    :key="item.groupCode"
                    :value="item.groupCode"
                    >{{ item.groupName }}</a-select-option
                  >
                </a-select>
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="8">所在院系</a-col>
              <a-col :span="16">
                <a-tree-select
                  style="width: 356px"
                  v-model:value="selectedCollege"
                  :tree-data="collegeList"
                  :replaceFields="{
                    children: 'childList',
                    title: 'groupName',
                    key: 'groupId',
                    value: 'groupId',
                  }"
                  :dropdownStyle="{ maxHeight: '300px' }"
                >
                  <template #suffixIcon
                    ><apartment-outlined class="ant-select-suffix"
                  /></template>
                </a-tree-select>
              </a-col>
            </a-row>

            <a-row>
              <a-col :span="8"></a-col>
              <a-col :span="16" style="padding-top: 50px">
                <a-button
                  type="primary"
                  style="margin-left: 120px"
                  @click="goSubmit"
                  >完成</a-button
                >
              </a-col>
            </a-row>
          </a-space>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, onMounted, reactive, toRefs } from "vue";
import {
  SettingOutlined,
  CloseOutlined,
  CheckCircleFilled,
} from "@ant-design/icons-vue";
import Http from "../../until/http";
import { debounce } from "lodash-es";
import {
  delCookie,
  getCookie,
  messageTips,
  setCookie,
} from "../../until/tools";
import { useRouter } from "vue-router";
export default defineComponent({
  components: {
    SettingOutlined,
    CloseOutlined,
    CheckCircleFilled,
  },

  setup() {
    const router = useRouter();
    const state = reactive({
      //认证有效期开关
      curDay: 1,
      authStatus: 0,
      currentIp: "",
      ipGroupList: [],
      currentIpOrg: "",
      orgList: [],
      selectedOrg: undefined,
      selectedCollege: undefined,
      collegeList: [],
    });

    const showTip = computed(() => {
      let result = false;
      state.ipGroupList.some((item) => {
        if (state.selectedCollege === item.collegeCode) {
          result = true;
          return true;
        }
      });
      return result;
    });

    onMounted(() => {
      let sync_location = getCookie("sync_location");
      if (sync_location) {
        delCookie("sync_location");
        router.push("/index");
        return false;
      }
      let sid = getCookie("z_sid");
      if (!sid) {
        router.push("/index");
        return false;
      }

      Http.getIpGroups().then((res) => {
        if (res) {
          if (res.ipGroupList.length == 0) {
            Object.assign(state, {
              curDay: 0,
            });
          }
          Object.assign(state, {
            currentIp: res.ip,
            ipGroupList: res.ipGroupList,
            currentIpOrg: res.ipGroupList[0]
              ? res.ipGroupList[0].collegeId
              : undefined,
          });
        }
      });
    });

    const selectCurrentOrg = () => {
      state.ipGroupList.some((item) => {
        if (item.collegeId === state.currentIpOrg) {
          Object.assign(state, {
            orgList: [{ groupCode: item.groupCode, groupName: item.groupName }],
            selectedOrg: item.groupCode,
          });
          getColleges(item.groupCode).then(() => {
            Object.assign(state, {
              selectedCollege: item.collegeId,
            });
          });
          return true;
        }
      });
    };

    const fetch = debounce((value) => {
      Http.searchOrg({ groupName: value }).then((res) => {
        if (res.list) {
          Object.assign(state, {
            orgList: res.list,
          });
        }
      });
    }, 300);

    const handleSearch = (val) => {
      if (val.length < 2) {
        return false;
      }
      if (val === "大学" || val === "学院" || val === "学校") {
        return false;
      }
      fetch(val);
    };

    const handleChange = (val) => {
      Object.assign(state, {
        selectedCollege: undefined,
      });
      getColleges(val);
    };

    const getColleges = (val) => {
      return Http.getOrgChildren({
        type: 1,
        isPerfect: 1,
        groupCode: val,
      }).then((res) => {
        if (res.groupList && res.groupList[0]) {
          if (res.groupList[0].parentId === "00") {
            let tsg = {
              groupCode: res.groupList[0].groupCode,
              groupName: "图书馆",
              groupId: res.groupList[0].groupId,
            };
            Object.assign(state, {
              collegeList: [tsg, ...res.groupList[0].childList],
            });
          }
        }
        return res;
      });
    };

    const filterOption = (inputvalue, option) => {
      let name = option.children[0].children;
      if (name.indexOf(inputvalue) === -1) {
        return false;
      } else {
        return true;
      }
    };

    const goSubmit = () => {
      if (!state.selectedCollege) {
        messageTips("请选择所在院系", 2);
        return false;
      }
      Http.goPerfectOrg({ collegeId: state.selectedCollege }).then((res) => {
        if (res) {
          if (res.success) {
            messageTips(res.message, 3);
            setCookie("sync_location", 1, { time: 1 });
            let locationTarget = getCookie("locationTarget");
            if (locationTarget) {
              delCookie("locationTarget");
              window.location.href = locationTarget;
            } else {
              window.location.reload();
            }
          } else {
            messageTips(res.message, 1);
          }
        }
      });
    };

    const closePage = () => {
      router.push("/index");
    };

    return {
      ...toRefs(state),
      selectCurrentOrg,
      handleSearch,
      handleChange,
      filterOption,
      showTip,
      goSubmit,
      closePage,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "../../scss/_variables.scss";
.container {
  background: #fff;
  overflow: hidden;
  .warp {
    width: 1200px;
    margin: 50px auto;
    padding: 12px 0;
    .content {
      width: 800px;
      margin: 0 auto;
      text-align: left;
      color: #333333;
      .title {
        font-size: 20px;
        font-weight: 600;
        line-height: 50px;
        .close-back {
          float: right;
          height: 30px;
          line-height: 28px;
          width: 30px;
          text-align: center;
          margin-top: 10px;
          cursor: pointer;
        }
      }
      .AddOrExpiry {
        height: 70px;
        line-height: 40px;
        border-bottom: 1px solid #e9e9e9;
        .red {
          color: rgb(231, 89, 52);
        }
        .anticon {
          margin-left: 5px;
        }
      }
      .relevant {
        margin-top: 40px;
        .setting {
          font-size: 20px;
          margin-top: -4px;
          position: relative;
          right: 5px;
        }
      }
    }
  }
}
</style>